import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Committee from "./pages/Committee";
import Speakers from "./pages/Speakers";
import KeynoteSpeakers from "./pages/KeynoteSpeakers";
import AbstractSubmission from "./pages/AbstractSubmission";
import Sponsorship from "./pages/Sponsorship";
import ImportantDates from "./pages/ImportantDates";
import Registration from "./pages/Registration";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Tourism from "./pages/Tourism";
import TravelPage from "./pages/Travel";
import Accommodation from "./pages/Accomodation";

function App() {
  return (
    <Router basename="/nclc-2026">
      <ScrollToTop />
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/invited-speaker" element={<Speakers />} />
            <Route path="/keynote-speaker" element={<KeynoteSpeakers />} />
            <Route
              path="/abstract-submission"
              element={<AbstractSubmission />}
            />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/important-dates" element={<ImportantDates />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/tourism" element={<Tourism />} />
            <Route path="/travel" element={<TravelPage />} />
            <Route path="/accommodation" element={<Accommodation />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
